'use client';

import React, { Suspense } from 'react';
import dynamic from 'next/dynamic';
import { ClerkProvider } from '@clerk/nextjs';
import PlausibleProvider from 'next-plausible';
import { Toaster } from 'react-hot-toast';

import { UIProvider } from '@rocket-house-productions/hooks';
import { ConfettiProvider } from '@rocket-house-productions/providers';
import NextTopLoader from 'nextjs-toploader';

const LogRocketComponent = dynamic(() => import('@rocket-house-productions/util').then(m => m.LogRocketComponent), {
  ssr: false,
  loading: () => null,
});

type ClientProvidersProps = {
  children: React.ReactNode;
};

// Defer LogRocket (or any module touching document/window at import time) to client only

export function ClientProviders({ children }: ClientProvidersProps) {
  return (
    <ClerkProvider>
      <PlausibleProvider src="https://plausible.biffify.com/js/script.js">
        <UIProvider>
          <ConfettiProvider />
          <NextTopLoader zIndex={999999} color="hsl(var(--accent)" height={5} showSpinner={false} shadow={false} />
          {children}
          <Toaster position="bottom-center" />
          <Suspense fallback={''}>
            <ClerkProvider dynamic>
              <LogRocketComponent />
            </ClerkProvider>
          </Suspense>
        </UIProvider>
      </PlausibleProvider>
    </ClerkProvider>
  );
}

export default ClientProviders;
